import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Field, Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import FormikMaskedInput from '../../../../../../CommonComponents/FormikMaskedInput';
import { emailMask } from '../../../../../../CommonComponents/MaskedInput';
import Spinner from '../../../../../../CommonComponents/Spinner';
import { PrimaryButton, SecondaryButton } from '../../../../../../CommonComponents/Button';
import { addEmail } from '../../../../../ExperianActions';
import { Footer, Label, LabelText } from '../../../../../components/EnrollForm/EnrollFormStyles';
import { Title } from '../../../ReportStyles';
import ExperianContext from '../../../../../ExperianContext';

const EmailForm = ({ onCancel, onRequestClose }) => {
  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={{
        email: '',
      }}
      onSubmit={async (values, actions) => {
        try {
          await dispatch(addEmail(clientId, subscriberId, values));
          onRequestClose();
          onCancel();
        } catch {
          // Keep the modal open to display the error
        } finally {
          actions.setSubmitting(false);
        }
      }}
      render={({ isSubmitting }) => (
        <Form>
          {isSubmitting && <Spinner />}
          <Title>Monitor Email Address</Title>
          <Label>
            <LabelText>Email address</LabelText>
            <Field
              type="text"
              name="email"
              component={FormikMaskedInput}
              mask={emailMask}
              size="small"
            />
          </Label>
          <Footer>
            <SecondaryButton onClick={onCancel}>Cancel</SecondaryButton>
            <PrimaryButton type="submit" disabled={isSubmitting}>
              Submit
            </PrimaryButton>
          </Footer>
        </Form>
      )}
    />
  );
};

EmailForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default EmailForm;
